import * as React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
// import Chip from '@material-ui/core/Chip'
// import Avatar from '@material-ui/core/Avatar'
import { withStyles } from '@material-ui/core/styles'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { removeBusinessLine} from './duck/actions'
import { getBusinessLineItemsFromSelections, getAssetClassItemsFromSelections } from '../lib/helpers'

const styles = (theme: any) => {
  return {
    chip: {
      marginRight: '10px',
      color: '#fff'
    },
    clickableAvatar: {
      cursor: 'pointer'
    }
  }
}

interface IProps extends RouteComponentProps<{}> {
  classSelections: number[]
  classesData: any[]
  classes: any
  businessLineSelections: number[]
  businessLinesData: any[]
  parentsOnly?: boolean
  removeBusinessLine: (id: number) => void
}

interface IChipDetails {
  name: string
  color: string
  id: number
}

const ContainerSlantB = styled.div`
  margin-right: 16px;
  font-size: 13px;
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #000;
  padding: 0.4em 2em 0.4em 2.5em;
  &:after {
    background-color: #e0e0e0;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-transform-origin: 100% 0;
    -ms-transform-origin: 100% 0;
    transform-origin: 100% 0;
    -webkit-transform: skew(-25deg);
    -ms-transform: skew(-25deg);
    transform: skew(-25deg);
    z-index: -1;
  }
`
const DeleteSpanA = styled.div`
  padding: 0 0.7em;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
  background-color: rgb(181,181,181);
  color: rbg(86,86,86);
  display: flex;
  jusify-content: center;
  align-items: center;
`
const TextSpanA = styled.span`
`

const ClassChips: React.SFC<IProps> = (props: IProps) => {
  // const classStyles = props.classes
  const { businessLinesData, businessLineSelections, classesData, classSelections} = props
  
  const goToAssets = () => {
    props.history.push('/views/new')
  }

  // Find and map currently selected asset classes
  const activeAssetClasses: IChipDetails[] = getAssetClassItemsFromSelections(classSelections,classesData)
    .map(classItem => ({
      name: classItem.name,
      color: '#e0e0e0',
      id: classItem.id
    }))

  // Find and map currently selected business lines
    const serviceLines: IChipDetails[] = getBusinessLineItemsFromSelections(businessLineSelections, businessLinesData)
    .map((bl: any) => {
      const color = bl.acf && bl.acf.chip_colour ? bl.acf.chip_colour : '#000'
      return {
        name: bl.name,
        color,
        id: bl.id
      }
    })

  const AssetClassChip = (classItem: IChipDetails) => {
    const ContainerSlantA = styled.div`
      margin-right: 16px;
      font-size: 13px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      color: #000;
      padding: 0.4em 2em 0.4em 3em;
      &:after {
        background-color: ${classItem.color};
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        -webkit-transform-origin: 100% 0;
        -ms-transform-origin: 100% 0;
        transform-origin: 100% 0;
        -webkit-transform: skew(-25deg);
        -ms-transform: skew(-25deg);
        transform: skew(-25deg);
        z-index: -1;
      }
    `
    return (
      <ContainerSlantA color={classItem.color}>
        <DeleteSpanA> <span> {classItem.name.slice(0, 2).toUpperCase()} </span> </DeleteSpanA>
        <TextSpanA>{classItem.name}</TextSpanA>
      </ContainerSlantA>
    )
  }
  // (
  //   <Chip
  //     style={{ backgroundColor: classItem.color, color: '#000' }}
  //     avatar={<Avatar>{classItem.name.slice(0, 2).toUpperCase()}</Avatar>}
  //     className={classStyles.chip}
  //     label={classItem.name}
  //   />
  // )
  
  const ServiceLineChip = (classItem: IChipDetails) => {
    const ContainerSlant = styled.div`
      margin-right: 16px;
      font-size: 13px;
      position: relative;
      display: inline-block;
      overflow: hidden;
      color: #fff;
      padding: 0.4em 2em 0.4em 2.5em;
      &:after {
        background-color: ${classItem.color};
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        -webkit-transform-origin: 100% 0;
        -ms-transform-origin: 100% 0;
        transform-origin: 100% 0;
        -webkit-transform: skew(-25deg);
        -ms-transform: skew(-25deg);
        transform: skew(-25deg);
        z-index: -1;
      }
    `
    const DeleteSpan = styled.div`
      padding: 0 0.7em;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 1px;
      cursor: pointer;
      background-color: rgb(181,181,181);
      color: rbg(86,86,86);
      display: flex;
      jusify-content: center;
      align-items: center;
    `
    const TextSpan = styled.span`
    `
    return (
      <ContainerSlant color={classItem.color}>
        <DeleteSpan onClick={() => props.removeBusinessLine(classItem.id) }> <span>X</span> </DeleteSpan>
        <TextSpan>{classItem.name}</TextSpan>
      </ContainerSlant>
    )
  }
  // (
  //   <Chip
  //     style={{ backgroundColor: classItem.color }}
  //     avatar={<Avatar className={classStyles.clickableAvatar} onClick={() => props.removeBusinessLine(classItem.id) }>X</Avatar>}
  //     label={classItem.name}
  //     className={classStyles.chip}
  //   />
  // )

  // Component can return list of asset classes and service lines or just asset classes
  if (props.parentsOnly) {
    return (
      <Outer>
        <div>
          {activeAssetClasses.map((classItem: IChipDetails, index: number) => (
            <React.Fragment key={index}>
              {AssetClassChip(classItem)}
            </React.Fragment>
          ))}
        </div>
      </Outer>
    )
  } else {
    return (
      <Outer>
        <div>
          {activeAssetClasses.map((classItem: IChipDetails, index: number) => (
            <React.Fragment key={index}>
              {AssetClassChip(classItem)}
            </React.Fragment>
          ))}
          {
            <ContainerSlantB>
              <DeleteSpanA onClick={goToAssets}> <span> + </span> </DeleteSpanA>
              <TextSpanA>{"Add Assets"}</TextSpanA>
            </ContainerSlantB>
          }
        </div>
        <div>
          {serviceLines.map((classItem: IChipDetails, index: number) => (
            <React.Fragment key={index}>
              {ServiceLineChip(classItem)}
            </React.Fragment>
          ))}
        </div>
      </Outer>
    )
  }
}

export default withRouter(
  withStyles(styles)(
    connect(
      (state: any) => ({
        classSelections: state.views.new.selections.classes,
        classesData: state.data.classes,
        businessLineSelections: state.views.new.selections.businessLines,
        businessLinesData: state.data.businessLines
      }),
      {removeBusinessLine}
    )(ClassChips)
  )
)

const Outer = styled.div`
  margin: 30px 0px;
  > div:last-child {
    margin-top: 20px;
  }
`



// WEBPACK FOOTER //
// ./src/views/ClassChips.tsx